
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Les 6 Meilleurs Thèmes WordPress Gratuits en 2026",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez les 6 meilleurs thèmes WordPress gratuits de 2026, alliant design moderne, fonctionnalités avancées et adaptabilité parfaite.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Les 6 Meilleurs Thèmes WordPress Gratuits en 2026",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez les 6 meilleurs thèmes WordPress gratuits de 2026, alliant design moderne, fonctionnalités avancées et adaptabilité parfaite.",
        },
      ],
    };
  },
};
